module.exports = __webpack_public_path__ + "static/Andsverkloven_43-b7cfc1ec782f18999718d44848e305ec.jpg";